import * as S from './styles'

type cardContainerProps = {
  backgroundColor?: '#017849' | '#fff'
  children: React.ReactNode
  style?: string
}

export const CardContainer = ({
  style = '',
  children,
  backgroundColor = '#fff'
}: cardContainerProps) => (
  <S.Wrapper className={style} style={{ backgroundColor: backgroundColor }}>
    {children}
  </S.Wrapper>
)
